import { render, staticRenderFns } from "./zichan.vue?vue&type=template&id=5a16c176&scoped=true"
import script from "./zichan.vue?vue&type=script&lang=js"
export * from "./zichan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a16c176",
  null
  
)

export default component.exports